
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`eUI is the component library of applications for the European Commission.`}</p>
    <p>{`It is in the process of integrating the components with native Angular code using HTML/CSS provided by the Europa Component Library (v2).`}</p>
    <p><a parentName="p" {...{
        "href": "https://eui.ecdevops.eu/screen/app/ecl/dev-guide"
      }}>{`https://eui.ecdevops.eu/screen/app/ecl/dev-guide`}</a></p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;